export default {
  title: {
    id: 'bo_seller-options-shipping-shipping_title',
    defaultMessage: 'Shipping',
  },
  listPerMarket: {
    id: 'merchant_options_shipping_methods_per_market_aria_label',
    defaultMessage: 'Shipping methods per market',
  },
  loading: {
    id: 'merchant_options_shipping_loading_shipping_methods',
    defaultMessage: 'Loading your shipping methods...',
  },
  add: {
    id: 'international_onboarding_shipping_add_another_method',
    defaultMessage: 'Add another method',
  },
  allCategories: {
    id: 'international_onboarding_shipping_all_categories',
    defaultMessage: 'All categories',
  },
  newVersionTitle: {
    id: 'bo_seller.options.shipping.new_version_title',
    defaultMessage:
      'We rolled out a new version of the shipping tab. Want to see it? {link, html}',
  },
  newVersionLink: {
    id: 'bo_seller.options.shipping.new_version_link',
    defaultMessage: 'Click here',
  },
} as const
